import { useCallback, useState, useEffect } from 'react';

import { LocalStorageKeys } from '@keaze/web/common/enums';
import { useLocalStorage } from '@keaze/web/hooks';






//  type UseMaxPrice = () => UseMaxPricEexpected;

export const UseMaxPrice = () => {


  useEffect(() => {
   
    const monthlyCostValue = localStorage.getItem('monthlyCost') 
    if (monthlyCostValue) {

      setmonthlyCostValue(monthlyCostValue);
 
    }
  }, []);
  

  let  DEFAULT_MONTLY_COST : any

  /// check this
  const [storedMonthlyCostValue, setstoredMonthlyCostValue] = useLocalStorage<string>(
    LocalStorageKeys.maxMonthlyCost,
    DEFAULT_MONTLY_COST


  );

  const [monthlyCostValue, setmonthlyCostValue] = useState<string>(storedMonthlyCostValue);


  return {
    monthlyCostValue,
    
  };
};
